export class LegacyMarketplaceDataBoundaryError extends Error {
  constructor() {
    super("This marketplace action requires the private authority service.");
    this.name = "LegacyMarketplaceDataBoundaryError";
    this.code = "marketplace/private-authority-required";
  }
}

const fail = () => {
  throw new LegacyMarketplaceDataBoundaryError();
};

// These compatibility names keep old UI branches fail-closed while each
// action is replaced with a bounded domain command. They deliberately do not
// accept or resolve Firestore paths.
export const legacyFirestoreCollection = fail;
export const legacyFirestoreDocument = fail;
export const legacyFirestoreRead = fail;
export const legacyFirestoreWrite = fail;
export const legacyFirestoreDelete = fail;
export const legacyFirestoreServerTimestamp = fail;
export const legacyFirestoreBatch = fail;
